/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createInfinity } from '../../factoriesAny.js';
export var InfinityDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createInfinity: createInfinity
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesInfinity.generated.js
// module id = 1566
// module chunks = 0